import React from "react";
import { PAGE_AREA } from "./page-area-events";
import styled from "styled-components";

// mosaic gets sad with size 0
const initialRect = { top: -10000, left: -10000, width: 50, height: 50 };

export let lastRect = {
  ...initialRect,
};

const Styled = {
  Container: styled.div`
    width: 100%;
    height: 100%;
  `,
};

export default class PageAreaReporter extends React.Component {
  private frameId;
  private container;

  componentDidMount() {
    this.frameId = requestAnimationFrame(() => this.onResize());
  }

  componentWillUnmount() {
    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
      this.handleRectUpdate(initialRect);
    }
  }

  onResize = () => {
    if (this.container) {
      this.handleRectUpdate({
        top: this.container.offsetTop,
        left: this.container.offsetLeft,
        width: this.container.offsetWidth,
        height: this.container.offsetHeight,
      });
    }
    this.frameId = requestAnimationFrame(this.onResize);
  };

  handleRectUpdate(rect) {
    const same = Object.keys(rect).reduce((acc, cv) => {
      return rect[cv] === lastRect[cv] && acc;
    }, true);

    if (!same) {
      lastRect = { ...rect };
      document.dispatchEvent(
        new CustomEvent(PAGE_AREA, { detail: { ...rect } })
      );
    }
  }

  render() {
    return <Styled.Container ref={(el) => (this.container = el)} />;
  }
}
